module.exports = __webpack_public_path__ + "img/hockey-stick-puck.7df81951.svg";